import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockMainHeroFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const mainHeroBlockConfig = {
  name: 'outer-block-hero',
  component: defineAsyncComponent(() => import('./CmsMainHeroBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./MainHero.vue')),
  fields: blockMainHeroFields,
} satisfies ModularBlockConfig;
